import api from '../api/axios.config';

export const ordersService = {
  getData: async(status, date_from, date_to, page, page_size, columnFilters = {}) => {
    try{
      const params = { };

      if (status?.length) params.status = status;
      if (date_from) params.date_from = date_from;
      if (date_to) params.date_to = date_to;
      if (page) params.page = page;
      if (page_size) params.page_size = page_size;

      Object.entries(columnFilters).forEach(([key, values]) => {
        if (values?.length) params[key] = values;
      });

      const response = await api.get(`/orders`, { params });

      return response.data;
    }
    catch(error){
      throw error;
    }
  },

  getStatusOptions: async( ) => {
    try{
      const response = await api.get(`/orders/status-options`);
  
      return response.data;
    }
    catch(error){
      throw error;
    }
  },

  getOrderDetails: async(orderId ) => {
    try{
      const params = { };
  
      if (orderId) params.order_id = orderId;

      const response = await api.get(`/orders/details`, { params });
  
      return response.data;
    }
    catch(error){
      throw error;
    }
  },

  uploadExcel: async (rawFile) => {
    const formData = new FormData();
    formData.append('file', rawFile);

    try{
      const response = await api.post(
          `/uploads/placed-orders`,
          formData,
          {
            headers: {
              "Content-Type": rawFile.type,
              "X-Filename": rawFile.name
            }
          }
      );
  
      return response.data;
    }
    catch(error){
      throw error
    }
  },

  updateStatus: async (order_id, status) => {
    try{
      const response = await api.patch(
          `/orders/status`,
          {
            updates: [
              {
                order_id,
                status,
              },
            ],
          },
      );
  
      return response.data;
    }
    catch(error){
      throw error
    }
  },

  updateOrderDetail: async (source_order_id, order_id, order_name, receival_date) => {
    try{
      const response = await api.patch(
          `/orders/details/?source_order_id=${source_order_id}`,
          {
            order_id: order_id,
            order_name: order_name,
            receival_date: receival_date
          }
      );
  
      return response.data;
    }
    catch(error){
      throw error
    }
  },

  updateOrderDetailId: async (source_order_id, order_id) => {
    try{
      const response = await api.patch(
          `/orders/details/?source_order_id=${source_order_id}`,
          {
            order_id: order_id
          }
      );
  
      return response.data;
    }
    catch(error){
      throw error
    }
  },

  updateOrderDetailName: async (source_order_id, order_name) => {
    try{
      const response = await api.patch(
          `/orders/details/?source_order_id=${source_order_id}`,
          {
            order_name: order_name
          }
      );
  
      return response.data;
    }
    catch(error){
      throw error
    }
  },

  updateOrderDetailReceivalDate: async (source_order_id, receival_date) => {
    try{
      const response = await api.patch(
          `/orders/details/?source_order_id=${source_order_id}`,
          {
            receival_date: receival_date
          }
      );
  
      return response.data;
    }
    catch(error){
      throw error
    }
  },
};
